import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

export default function LoadingPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#f5f5f5"
    >
      <CircularProgress />
      <Typography variant="h6" style={{ marginTop: '20px' }}>
        Loading...
      </Typography>
    </Box>
  );
}